export const SPAN_SCOPE = {
    REPORT_SCOPE: 'REPORT_SCOPE',
};
